/* eslint-disable no-unused-vars */
import React, { useMemo } from 'react'

import { FieldViewLink, OptionSelector } from '@/components'
import { editCustomerPath, generatePath } from '@/utils'
import { CustomerNode } from '@/apollo/graphql'
import { Maybe } from '@/types'
import { t } from '@/i18n'

import { useSelect } from './useSelect'

interface Props {
  isEditing?: boolean
  initial?: Maybe<Partial<CustomerNode>>
  selected?: string
  [x: string]: any
}

const CustomerSelector: React.FC<Props> = ({
  isEditing,
  initial,
  selected,
  ...rest
}) => {
  const { customerOptions, loading, pageInfo, onFetchMore, onSearch } =
    useSelect({
      initial,
    })

  const selectedCustomer = useMemo(() => {
    if (selected) {
      return customerOptions.find(c => c.value === selected)
    }

    return null
  }, [customerOptions, selected])

  const emptyValue = useMemo(() => (isEditing ? '' : '...'), [isEditing])

  if (!isEditing && selectedCustomer) {
    return (
      <FieldViewLink
        label={t('customer')}
        linkLabel={selectedCustomer?.label}
        link={generatePath(editCustomerPath, {
          id: selectedCustomer?.value,
        })}
      />
    )
  }

  return (
    <OptionSelector
      {...rest}
      isSearchable
      isAsync
      name="customer"
      menuPlacement="top"
      options={customerOptions}
      optionsLoading={loading}
      emptyValue={emptyValue}
      disabled={!Boolean(isEditing)}
      label={t('customer')}
      fetchMoreStatus={pageInfo.fetchMoreStatus}
      onFetchMore={onFetchMore}
      onSearch={onSearch}
    />
  )
}

export default CustomerSelector
